<template>
  <div class="notification-item-wrapper">
    <v-row class="align-center cursor-pointer" @click="pushRoute">

      <v-col class="col-auto pe-2">
        <div :class="['notif-dot', { 'notif-dot--hidden': notif.isRead }]"></div>
      </v-col>

      <v-col class="col-auto pe-2">
        <v-avatar size="32" color="grey lighten-3">
          <v-icon :color="getColor(notif)">fas fa-circle-exclamation</v-icon>
        </v-avatar>
      </v-col>

      <v-col class="col">
        <div v-if="!isEmptyHtml(notif.contexte)" class="notification-etab">{{ notif.contexte }}</div>
        <div v-if="!isEmptyHtml(notif.label)" class="notification-label">{{ notif.label }}</div>
        <div v-if="!isEmptyHtml(notif.detail)" class="notification-description">{{ truncate(notif.detail) }}</div>
      </v-col>

      <v-col class="col-auto text-right">
        <div class="notification-date">
          {{ displayNotificationDateTime(notif.echeance) }}
        </div>
        <v-icon
            v-if="showInfoIcon(notif)"
            color="grey lighten-1"
            size="20"
            class="mt-1"
            @click.stop="deleteNotification(notif)"
        >
          fas fa-xmark
        </v-icon>
      </v-col>

    </v-row>
  </div>
</template>



<script lang="ts">
import Notif from '@/generated/classes/Notif';
import moment from 'moment';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    notif: {
      type: Object as PropType<Notif>
    }
  },
  methods: {
    isEmptyHtml(value: string): boolean {
      return !value || value == "<div><br></div>";
    },
    truncate(text: string, max: number = 100) {
      if (!text) return "";
      return text.length > max ? text.substring(0, max) + "..." : text;
    },
    pushRoute(): void {
      this.$emit('selected', this.notif);
    },
    getColor(notif: Notif): string {
      let res = "";
      if (notif.type == NotifDefTypes.INFO) {
        res = 'rgb(var(--v-theme-information80))';
      } else if (notif.type == NotifDefTypes.ACTION) {
        res = res = 'rgb(var(--v-theme-action80))';
      } else {
        res = 'var(--v-colorSemanticError-base)';
      }
      return res;
    },
    showInfoIcon(notif: Notif): boolean {
      return notif.type == NotifDefTypes.INFO;
    },
    displayNotificationDateTime(date: Date): string {
      moment.locale('fr');
      if (moment(date).isSame(moment(), 'day')) {
        return 'Aujourd\'hui à ' + moment(date).format('HH:mm');
      } else {
        return moment(date).format('D MMM') + ' à ' + moment(date).format('HH:mm');
      }
    },
    async deleteNotification() {
      this.$emit('deleted', this.notif);
    }
  }
})

</script>
<style scoped>
.cursor-pointer{
  cursor: pointer;
}
</style>
